import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { api_gateway } from '../../conexoes/api'
import { revelarAlterarLogin } from '../../redux/actions/index'
import {
  elipseVerde,
  exclamacao,
  fecharJanela
} from '../../utils/alternanciaIcones'
import decryptJWT from '../../utils/decryptJWT'
import MensagemAtencao from '../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../componentesModais/mensagens/mensagemSucesso'
import SpinerVeye from '../spinnerVeye/spinnerVeye.js'
import './alterarLogin.css'

export default function DesativarDemonstracao() {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const { handleSubmit, register, errors } = useForm()
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [habilitarEdicao, setHabilitarEdicao] = useState(true)
  const [email, setEmail] = useState('')
  const [nome, setNome] = useState('')

  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const despacho = useDispatch()
  const modal = useRef()
  const iconeAlerta = (
    <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
  )

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  useEffect(() => {
    setSpinAtivo(true)
    async function handleCarregarDados() {
      await api_gateway
        .get('/m1/consultar/usuario?cd_pav_usuario=' + decryptJWT('codigo'))
        .then((resolve) => {
          if (resolve.data.status === 200 && resolve.data.dados.length != 0) {
            setEmail(resolve.data.dados[0].ds_email)
            setNome(resolve.data.dados[0].ds_pav_usuario)
          }
          setSpinAtivo(false)
        })
    }
    handleCarregarDados()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (email !== '' && nome !== '') setHabilitarEdicao(false)
    else setHabilitarEdicao(true)
  }, [email, nome])

  async function handleSalvar() {
    setSpinAtivo(true)
    await api_gateway
      .post(
        '/m1/alterar/usuario',
        {
          dados: {
            ds_email: email,
            ds_pav_usuario: nome
          },
          condicao: {
            cd_pav_usuario: decryptJWT('codigo')
          }
        },
        { timeout: 20000 }
      )
      .then(function () {
        handleCancelar()
      })
      .catch(function () {
        setMensagemErro('Erro na alteracao de email')
        handleMensagemErro(false)
      })
      .finally(() => {
        setSpinAtivo(false)
      })
  }

  async function handleCancelar() {
    setSpinAtivo(false)
    despacho(revelarAlterarLogin(false))
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleMensagemAtencao() {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      handleCancelar()
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleSalvar()
    }
  }

  async function handleReconstruirToken() {
    const request =
      '/m1/servicos/alterar_token?login=' +
      decryptJWT('email') +
      '&email=' +
      email +
      '&codigo=' +
      decryptJWT('codigo') +
      '&codigoCliente=' +
      decryptJWT('codigoCliente') +
      '&codigoClienteErpAntigo=' +
      decryptJWT('codigoClienteErpAntigo') +
      '&nomeDeUsuario=' +
      nome +
      '&perfil=' +
      decryptJWT('perfil') +
      '&cdSmsContaUsuario=' +
      decryptJWT('cdSmsContaUsuario') +
      '&id=' +
      decryptJWT('id') +
      '&clienteNivel=' +
      decryptJWT('clienteNivel') +
      '&tipoPerfil=' +
      decryptJWT('tipoPerfil') +
      '&clientePrimario=' +
      decryptJWT('clientePrimario')
    await api_gateway
      .get(request)
      .then(function (response) {
        localStorage.setItem('@veye-Token', response.data.dados.token)
        handleMensagemSucesso()
      })
      .catch(function (error) {
        console.error(error)
      })
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleReconstruirToken())}>
      <div className="modal-alterar-senha fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Alterar login</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row className="usuario-dados-corpo-linha">
          <Col>
            <div className="corpo-dados-usuario-email">
              <Form.Label>
                {' '}
                <div className="fonte-cor-1 label-campo">E-mail</div>{' '}
              </Form.Label>
              <Form.Control
                className="campo-texto-cor-3 campo-texto"
                type="text"
                maxLength="255"
                name="ds_email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                ref={register({
                  required: true,
                  validate: {
                    minimo: (value) =>
                      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) == true
                  }
                })}
              />
              {errors.ds_email && (
                <p className="fonte-cor-3 label-alerta">
                  {iconeAlerta} Insira um email valido.
                </p>
              )}
            </div>
          </Col>
          <Col>
            <div className="corpo-dados-usuario-email">
              <Form.Label>
                {' '}
                <div className="fonte-cor-1 label-campo">
                  Nome de saudação
                </div>{' '}
              </Form.Label>
              <Form.Control
                className="campo-texto-cor-3 campo-texto"
                type="text"
                maxLength="255"
                value={nome}
                name="ds_nome"
                onChange={(e) => setNome(e.target.value)}
                ref={register({
                  required: true,
                  validate: { minimo: (value) => value.length > 1 }
                })}
              />
              {errors.ds_nome && (
                <p className="fonte-cor-3 label-alerta">
                  {iconeAlerta} O campo é obrigatório.
                </p>
              )}
            </div>
          </Col>
        </Form.Row>
        <Form.Row className="espaco-reativar-linha">
          <Col>
            <Button
              type="submit"
              className={
                habilitarEdicao
                  ? 'botao-confirmar-desabilitado'
                  : 'botao-confirmar'
              }
              variant="success"
              size="sm"
            >
              <div className="fonte-cor-4">Confirmar</div>
            </Button>
            <Button
              className="botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar()}
            >
              <div className="fonte-cor-2">Cancelar</div>
            </Button>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Seu login foi alterado."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Remover Linha?"
              mensagemBotao="Remover"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
    </Form>
  )
}
